const LOCK_PROPERTY = "--hidden--";

let activeLocks = 0;

export function acquireScrollLock(): () => void {
  activeLocks += 1;
  if (activeLocks === 1) document.documentElement.style.setProperty(LOCK_PROPERTY, "hidden");
  let released = false;
  return () => {
    if (released) return;
    released = true;
    activeLocks -= 1;
    if (activeLocks === 0) document.documentElement.style.setProperty(LOCK_PROPERTY, "auto");
  };
}
